<cc-side-bar class="clearing-filter-toolbar" [(sidebarToggled)]="filterToolbarToggled"
             (sidebarToggledChange)="SizeChanged($event)" [menuItemsTop]="menuItemsTop"
             [menuItemsBottom]="menuItemsBottom">
  <app-pl-residual-table-button top
                                [selectedOrderIds]="selectedOrderIds"
                                [tradeModeEnabled]="tradeModeEnabled"></app-pl-residual-table-button>
  <span top
        class="bar-button state-filter state-filter-all {{ordersTradesFilter.stateFilter===StateFilter.ALL?'bar-button-active':''}}"
        [pTooltip]="transPartKey+'stateAll'|translate"
        (click)="changeState(StateFilter.ALL)">
     <div class="state-filter-ico">
      <i class="fas fa-user state-filter-ico-part1"></i>
      <i class="fas fa-globe state-filter-ico-part2"></i>
     </div>
      <div class="state-filter-text">{{ transPartKey + 'stateAll' | translate }}</div>
    </span>
  <span top
        class="bar-button state-filter state-filter-unallocated {{ordersTradesFilter.stateFilter===StateFilter.UNALLOCATED?'bar-button-active':''}}"
        [pTooltip]="transPartKey+'stateUnallocated'|translate"
        (click)="changeState(StateFilter.UNALLOCATED)">
     <div class="state-filter-ico">
       <i class="fas fa-user state-filter-ico-part1"></i>
      <i class="fas fa-info-circle state-filter-ico-part2"></i>
     </div>
      <div class="state-filter-text">{{ transPartKey + 'stateUnallocated' | translate }}</div>
    </span>
  <span top
        class="bar-button state-filter state-filter-non-giveup {{ordersTradesFilter.stateFilter===StateFilter.NON_GIVEUP?'bar-button-active':''}}"
        [pTooltip]="transPartKey+'stateNonGiveup'|translate"
        (click)="changeState(StateFilter.NON_GIVEUP)">
     <div class="state-filter-ico">
      <i class="fas fa-user state-filter-ico-part1"></i>
      <i class="fas fa-check-circle state-filter-ico-part2"></i>
     </div>
      <div class="state-filter-text">{{ transPartKey + 'stateNonGiveup' | translate }}</div>
    </span>
  <span top
        class="bar-button state-filter state-filter-cleared {{ordersTradesFilter.stateFilter===StateFilter.CLEARED?'bar-button-active':''}}"
        [pTooltip]="transPartKey+'stateCleared'|translate"
        (click)="changeState(StateFilter.CLEARED)">
     <div class="state-filter-ico">
      <i class="fas fa-user state-filter-ico-part1"></i>
      <i class="fas fa-check-circle state-filter-ico-part2"></i>
     </div>
      <div class="state-filter-text">{{ transPartKey + 'stateCleared' | translate }}</div>
    </span>
  <span top
        class="bar-button state-filter state-filter-accepted {{ordersTradesFilter.stateFilter===StateFilter.ACCEPTED?'bar-button-active':''}}"
        [pTooltip]="transPartKey+'stateAccepted'|translate"
        (click)="changeState(StateFilter.ACCEPTED)">
     <div class="state-filter-ico">
      <i class="fas fa-user state-filter-ico-part1"></i>
      <i class="fas fa-cog state-filter-ico-part2"></i>
     </div>
      <div class="state-filter-text">{{ transPartKey + 'stateAccepted' | translate }}</div>
    </span>
  <span top
        class="bar-button state-filter state-filter-giveup {{ordersTradesFilter.stateFilter===StateFilter.GIVEUP?'bar-button-active':''}}"
        [pTooltip]="transPartKey+'stateGiveup'|translate"
        (click)="changeState(StateFilter.GIVEUP)">
     <div class="state-filter-ico">
      <i class="fas fa-user state-filter-ico-part1"></i>
      <i class="fas fa-cog state-filter-ico-part2"></i>
     </div>
      <div class="state-filter-text">{{ transPartKey + 'stateGiveup' | translate }}</div>
    </span>
  <span top
        class="bar-button state-filter state-filter-rejected {{ordersTradesFilter.stateFilter===StateFilter.REJECTED?'bar-button-active':''}}"
        [pTooltip]="transPartKey+'stateRejected'|translate"
        (click)="changeState(StateFilter.REJECTED)">
     <div class="state-filter-ico">
      <i class="fas fa-user state-filter-ico-part1"></i>
      <i class="fas fa-times-circle state-filter-ico-part2"></i>
     </div>
      <div class="state-filter-text">{{ transPartKey + 'stateRejected' | translate }}</div>
    </span>
  <ng-content body select="[body]"></ng-content>
  <app-archive-report-total-residual-adjust-button *ngIf="isTotalResidualAdjustmentAdmin" bottom
                                                   [class]="'report-total-residual-adjust-button'"></app-archive-report-total-residual-adjust-button>
  <app-archive-tasks-button *ngIf="hasRecapTask" bottom [origins]="[Origin.WEB_RECAP]"
                            [buttonTitle]="'page.profile.recap.tasks'"
                            [transPartKey]="'profile.recap.task'"></app-archive-tasks-button>


  <app-allocation-tasks-button *ngIf="isClearingAdmin" bottom></app-allocation-tasks-button>
  <app-hogo-button *ngIf="hogoEnabled" bottom></app-hogo-button>

</cc-side-bar>

<app-archive-recap-list-dialog [(dialogFormVisible)]="recapListDialogVisible"></app-archive-recap-list-dialog>
<app-order-amendment-dialog [(dialogFormVisible)]="orderAmendmentListDialogVisible"></app-order-amendment-dialog>
<app-flex-add-form-dialog *ngIf="this.appConfigService.flexEnabled" #flexDialogAddForm></app-flex-add-form-dialog>
<app-flex-add-orders-form-dialog *ngIf="this.appConfigService.flexEnabled" #flexDialogAddOrdersForm></app-flex-add-orders-form-dialog>


<!--<app-filters-form [(dialogFormVisible)]="filtersFormVisible" [orderView]="orderViewTemplate"-->
<!--                  [tradeView]="tradeViewTemplate" [(ordersTradesFilter)]="ordersTradesFilter"-->
<!--                  (ordersTradesFilterChange)="ordersTradesFilterChange.emit($event)"></app-filters-form>-->
